import initialize from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-contact/actions/initialize.js';

export default {
    initialize,
};